module.exports = __webpack_public_path__ + "img/dashboard.98db8e54.svg";